import createBaseService from "@/api/base-service";
import type { GeneratedBom } from "../../types/generated-bom";

const generatedBomService = {
	...createBaseService<GeneratedBom>("/generated-boms"),
};

export default generatedBomService;
